import { FormikProps } from "formik";
import { useContext } from "react";
import { SubmitPseudonymViewModel } from "../../../../generated/data-contracts";
import { FormikUtils } from "../../../../utils";
import { isTabletOrMobileView } from "../../../shared/appStates/appStates";
import { AvisSaveButton } from "../../../shared/components/buttons";
import { AvisInputText } from "../../../shared/components/inputs";
import { AvisContext } from "../../../shared/context/AvisContext";

interface ISubmitNameFormProps {
  bag: FormikProps<SubmitPseudonymViewModel>;
  loading: boolean;
  showModal: () => void;
}

export function SubmitNameForm(props: Readonly<ISubmitNameFormProps>) {
  const { bag, loading, showModal } = props;
  const { res } = useContext(AvisContext);

  const onSubmitPrompt = async () => {
    const errors = await bag.validateForm();
    if (Object.keys(errors).length > 0) return;

    showModal();
  };

  const renderButton = (
    <AvisSaveButton
      className="m-0"
      onClick={onSubmitPrompt}
      disabled={loading}
    />
  );

  return (
    <div>
      <div className="avis-form-short">
        <AvisInputText<SubmitPseudonymViewModel>
          label={res("authors_NamesPage_Pseudonym_Label")}
          placeholder={res("authors_NamesPage_Pseudonym_Placeholder")}
          bag={bag}
          bagField="pseudonym"
          disabled={loading}
          minLength={2}
          maxLength={100}
          spacing="medium"
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, onSubmitPrompt)}
          sideRightIcons={
            isTabletOrMobileView.value ? undefined : [renderButton]
          }
          required
          reserveErrorMessageSpace={true}
        />
      </div>
      {isTabletOrMobileView.value && renderButton}
    </div>
  );
}
